import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
    public get shortStringLength() { return 50; }
    public get longStringLength() { return 200; }
    public get emailStringMinLength() { return 3; }
    public get emailStringMaxLength() { return 254; }
}


// WEBPACK FOOTER //
// ./src/app/globals/globals.ts